import { Box, Card, Thumbnail } from '@nimbus-ds/components';
import {
  PaymentProviderOptionsResponseDto,
  PaymentOptionInfoDto,
} from '@tiendanube/common';
import { InterfaceNameChecked } from '@tiendanube/components';
import { VirtualInteractiveList } from 'commons/components';
import './PaymentOptions.scss';
import { PaymentOptionRow } from './PaymentOptionRow';

interface PaymentOptionListProps {
  activePaymentOptions: PaymentProviderOptionsResponseDto[];
  paymentOptions: PaymentOptionInfoDto[];
  onChange: (event: InterfaceNameChecked) => void;
}

export function PaymentOptionList({
  activePaymentOptions,
  paymentOptions,
  onChange,
}: Readonly<PaymentOptionListProps>) {
  return (
    <Box display="flex" flexDirection="column" gap="4">
      {activePaymentOptions.map(
        (activePaymentOption: PaymentProviderOptionsResponseDto) => (
          <Card key={activePaymentOption.paymentProviderName}>
            <Card.Header>
              <div
                className={`stratus--payment-option-image ${
                  activePaymentOption.usesCustomLogoBackground &&
                  'custom-background-color'
                }`}
              >
                <Thumbnail
                  aspectRatio="2/1"
                  width="88px"
                  alt={activePaymentOption.paymentProviderName}
                  src={activePaymentOption.logoUrl}
                />
              </div>
            </Card.Header>
            <Card.Body>
              <Box display="flex" flexDirection="column">
                <VirtualInteractiveList
                  totalCount={activePaymentOption.checkoutPaymentOptions.length}
                  itemContent={(index: number) => {
                    const currentOption =
                      activePaymentOption.checkoutPaymentOptions[index];
                    const isSelected = paymentOptions.some(
                      (option) => option.id === currentOption.id,
                    );

                    return (
                      <PaymentOptionRow
                        paymentProviderName={
                          activePaymentOption.paymentProviderName
                        }
                        option={currentOption}
                        isSelected={isSelected}
                        onChange={onChange}
                      />
                    );
                  }}
                />
              </Box>
            </Card.Body>
          </Card>
        ),
      )}
    </Box>
  );
}
